// Generated by CoffeeScript 2.7.0
var Admin__Messages__SearchesController, MESSAGE_FILTERS, MessageFilter;

import MessagesSidebar from '../../share/tag_group_sidebar.js';

import AttributeFilter from 'trunks/vue/admin/compositions/message_filters/attribute_filter.js';

import IdentityFilter from 'trunks/vue/admin/compositions/message_filters/identity_filter.js';

import MessageGroupIdFilter from 'trunks/vue/admin/compositions/message_filters/message_group_id_filter.js';

import StatusFilter from 'trunks/vue/admin/compositions/message_filters/status_filter.js';

import TagIdFilter from 'trunks/vue/admin/compositions/message_filters/tag_id_filter.js';

import TypeFilter from 'trunks/vue/admin/compositions/message_filters/type_filter.js';

MESSAGE_FILTERS = {AttributeFilter, IdentityFilter, MessageGroupIdFilter, StatusFilter, TagIdFilter, TypeFilter};

MessageFilter = class MessageFilter {
  constructor(element) {
    if (this.element == null) {
      this.element = DomMaster.wrap(element);
    }
    if (this.open_flag_el == null) {
      this.open_flag_el = DomMaster.wrap(event._target).find('i');
    }
    if (this.filter_popover == null) {
      this.filter_popover = new Skylark.Elements.Popover(this.element, {
        beforeOpenFunc: (popover) => {
          this.open_flag_el.removeClass('slp-chevron-right');
          this.open_flag_el.addClass('slp-chevron-left');
          if (this.filter) {
            return this.filter.reset();
          } else {
            this.filter_name = this.element.data('filter-name');
            this.filter = new MESSAGE_FILTERS[this.element.data('filter-type')]({
              el: this.element.find('.filter-item-content').node,
              propsData: {
                initialSelectedOptionIds: _.compact(this.element.data('value').split(','))
              }
            });
            return this.filter.$on('cancelClicked', () => {
              return this.filter_popover.close();
            }).$on('submitClicked', (value) => {
              var filter_options;
              filter_options = {};
              filter_options[this.filter_name] = value;
              $currentController.advancedQueryInput.doQueryWithParams({
                filter_options: filter_options
              });
              return this.filter_popover.close();
            });
          }
        },
        beforeCloseFunc: (popover) => {
          this.open_flag_el.removeClass('slp-chevron-left');
          return this.open_flag_el.addClass('slp-chevron-right');
        }
      });
    }
    this.filter_popover.open();
  }

};

export default Admin__Messages__SearchesController = (function() {
  class Admin__Messages__SearchesController extends Skylark.App.BaseController {
    show() {
      new Skylark.Elements.QueryInput(DomMaster.find('.js_query_input'));
      return this.__bindEditTags();
    }

    advanced() {
      $currentController.advancedQueryInput = new Skylark.Elements.AdvancedQueryInput(DomMaster.find('.js_query_input'));
      this.__bindEditTags();
      DomMaster.find('.message-filters').node.proxy('click', '.message-filter-item', function(event) {
        var base, filter_el;
        filter_el = DomMaster.wrap(event._target);
        return (base = filter_el.node)._filter_popover != null ? base._filter_popover : base._filter_popover = new MessageFilter(filter_el);
      });
      return DomMaster.find('.message-filter-chips').node.proxy('click', '.chip i', function(event) {
        var filter_name, filter_options;
        filter_name = DomMaster.wrap(event._target).closest('.chip').data('filter-name');
        filter_options = {};
        filter_options[filter_name] = [];
        return $currentController.advancedQueryInput.doQueryWithParams({
          filter_options: filter_options
        });
      });
    }

  };

  Admin__Messages__SearchesController.include(MessagesSidebar);

  return Admin__Messages__SearchesController;

}).call(this);
